import { compose } from 'recompose';
import FieldsName from './fieldsName';

const enhance = compose();
export default enhance(FieldsName);
